import { render, staticRenderFns } from "./deleteMenuGroupCatalog.vue?vue&type=template&id=f2eba54a"
import script from "./deleteMenuGroupCatalog.vue?vue&type=script&lang=js"
export * from "./deleteMenuGroupCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports